import { api, direRefus } from '../api.ts';
import { $, brut, h, peindre, valeur } from '../ui.ts';

const cadre = (dedans: ReturnType<typeof h>) => h`
  <div style="min-height:100vh;display:flex;flex-direction:column">
    <div class="pousse" style="display:flex;align-items:center;justify-content:center;padding:40px 24px">
      <div style="width:100%;max-width:420px;display:flex;flex-direction:column;gap:24px">
        <div style="display:flex;align-items:baseline;gap:11px">
          <span style="font:400 32px/1 var(--serif);color:var(--obsidian);letter-spacing:1px">MANA</span>
          <span style="width:22px;height:1px;background:var(--copper);display:inline-block;transform:translateY(-9px)"></span>
          <span style="font-size:10px;color:var(--basalt);letter-spacing:1.6px">WAKEA</span>
        </div>
        ${dedans}
      </div>
    </div>
    <div style="height:52px;border-top:1px solid var(--hair);display:flex;align-items:center;justify-content:space-between;padding:0 28px" class="pt sourd">
      <span>WAKEA · Advisory &amp; Operating Partner</span><span>Accès réservé au cabinet</span>
    </div>
  </div>`;

const etape1 = () => cadre(h`
  <p class="sm sourd" style="margin:0">Accès réservé aux collaborateurs et Partners du cabinet.</p>
  <form id="f" style="display:flex;flex-direction:column;gap:15px">
    <div><label class="lab" for="email">ADRESSE PROFESSIONNELLE</label>
      <input class="champ" id="email" type="email" autocomplete="username" required></div>
    <div><label class="lab" for="mdp">MOT DE PASSE</label>
      <input class="champ" id="mdp" type="password" autocomplete="current-password" required></div>
    <p class="err" id="err" hidden></p>
    <button class="bt p" style="height:40px;justify-content:center" type="submit">Continuer</button>
    <button class="sm" type="button" data-act="oubli" style="color:var(--copper);align-self:flex-start">
      Mot de passe oublié ou premier accès</button>
  </form>`);

const etape2 = () => cadre(h`
  <div><span class="sur">ÉTAPE 2 · SECOND FACTEUR</span>
    <div style="font:400 24px/1.2 var(--serif);color:var(--obsidian);margin-top:8px">Code d'authentification</div>
    <p class="sm sourd" style="line-height:1.6">Ouvrez votre application d'authentification et saisissez le code à six chiffres.
      Un code de secours fonctionne aussi.</p></div>
  <form id="f" style="display:flex;flex-direction:column;gap:15px">
    <div><label class="lab" for="code">CODE</label>
      <input class="champ" id="code" inputmode="numeric" autocomplete="one-time-code"
             style="font-size:20px;letter-spacing:6px" maxlength="12" required></div>
    <p class="err" id="err" hidden></p>
    <button class="bt p" style="height:40px;justify-content:center" type="submit">Ouvrir MANA</button>
  </form>`);

function dire(message: string) {
  const n = $('#err');
  if (n) { n.textContent = message; n.hidden = false; }
}

export function ecranConnexion(reprendre: () => void): void {
  let etape: 1 | 2 = 1;

  const poser = () => {
    peindre('#app', etape === 1 ? etape1() : etape2());
    $('#f')?.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const bouton = $<HTMLButtonElement>('#f button[type=submit]');
      if (bouton) bouton.disabled = true;
      try {
        if (etape === 1) {
          await api.post('/api/auth/connexion', { email: valeur('#email'), mdp: valeur('#mdp') });
          etape = 2; poser();
        } else {
          await api.post('/api/auth/second-facteur', { code: valeur('#code') });
          reprendre();
        }
      } catch (e) {
        dire(direRefus(e));
        if (bouton) bouton.disabled = false;
      }
    });

    // L'écouteur est posé sur le bouton lui-même, à chaque rendu. Une écoute globale
    // « once » se consommait au premier clic venu — dans le champ d'adresse, par
    // exemple — et le bouton ne répondait plus jamais.
    $('[data-act="oubli"]')?.addEventListener('click', async () => {
      const email = valeur('#email');
      if (!email) return dire('Saisissez d’abord votre adresse professionnelle.');
      await api.post('/api/auth/mot-de-passe-oublie', { email }).catch(() => {});
      peindre('#app', cadre(h`
        <div class="enc gl"><span class="sur">COURRIEL ENVOYÉ</span>
          <p>Si cette adresse correspond à un compte, un lien vient de partir. Il expire dans une
             heure et ne fonctionne qu'une fois.</p></div>
        <a href="/" class="sm">Revenir à la connexion</a>`));
    });
  };
  poser();
}

/** Premier mot de passe et réinitialisation passent par le même écran, appelé depuis le lien reçu. */
export function ecranAcces(jeton: string, reprendre: () => void): void {
  const poserMdp = () => {
    peindre('#app', cadre(h`
      <div><span class="sur">VOTRE ACCÈS</span>
        <div style="font:400 24px/1.2 var(--serif);color:var(--obsidian);margin-top:8px">Choisir un mot de passe</div>
        <p class="sm sourd">Douze caractères au moins, et trois familles sur quatre : minuscules, majuscules,
           chiffres, symboles.</p></div>
      <form id="f" style="display:flex;flex-direction:column;gap:15px">
        <div><label class="lab" for="mdp">MOT DE PASSE</label>
          <input class="champ" id="mdp" type="password" autocomplete="new-password" required></div>
        <div><label class="lab" for="mdp2">RÉPÉTEZ-LE</label>
          <input class="champ" id="mdp2" type="password" autocomplete="new-password" required></div>
        <p class="err" id="err" hidden></p>
        <button class="bt p" style="height:40px;justify-content:center" type="submit">Enregistrer</button>
      </form>`));

    $('#f')?.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      if (valeur('#mdp') !== valeur('#mdp2')) return dire('Les deux saisies diffèrent.');
      try {
        const r = await api.post<{ etape: string; url?: string; secret?: string; codes_secours?: string[] }>(
          '/api/auth/mot-de-passe', { jeton, mdp: valeur('#mdp') });
        if (r.etape === 'appairage' && r.secret) appairer(r.secret, r.codes_secours ?? []);
        else location.href = '/';
      } catch (e) { dire(direRefus(e)); }
    });
  };

  const appairer = (secret: string, secours: string[]) => {
    peindre('#app', cadre(h`
      <div><span class="sur">SECOND FACTEUR</span>
        <div style="font:400 24px/1.2 var(--serif);color:var(--obsidian);margin-top:8px">Appairer votre téléphone</div>
        <p class="sm sourd">Dans Google Authenticator, ajoutez un compte par saisie manuelle et recopiez cette clé.</p></div>
      <div class="carte k"><div class="lab">CLÉ</div>
        <code style="font-size:15px;letter-spacing:2px;word-break:break-all">${secret}</code></div>
      <div class="enc ar"><span class="sur">CODES DE SECOURS · ${secours.length}</span>
        <p>Ils ne seront plus jamais affichés. Conservez-les hors de cet outil ; chacun ne sert qu'une fois.</p>
        <code class="sm" style="line-height:1.9">${brut(secours.join(' · '))}</code></div>
      <form id="f" style="display:flex;flex-direction:column;gap:15px">
        <div><label class="lab" for="code">CODE AFFICHÉ PAR L'APPLICATION</label>
          <input class="champ" id="code" inputmode="numeric" maxlength="6"
                 style="font-size:20px;letter-spacing:6px" required></div>
        <p class="err" id="err" hidden></p>
        <button class="bt p" style="height:40px;justify-content:center" type="submit">Terminer et entrer</button>
      </form>`));

    $('#f')?.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      try {
        await api.post('/api/auth/appairage', { code: valeur('#code') });
        history.replaceState(null, '', '/');
        reprendre();
      } catch (e) { dire(direRefus(e)); }
    });
  };

  poserMdp();
}
